module.exports = __webpack_public_path__ + "img/contact.35d9ed35.svg";